var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-page"},[_c('div',{staticClass:"centered"},[_c('h1',[_vm._v("403")]),_c('p',[_vm._v(" You are not authorized to access "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.resourceName))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }